(() => {
  const DESKTOP_FORM_ID = 'XWERnq';
  const MOBILE_FORM_ID = 'R4qKJJ';
  const WELCOME_FORM_IDS = [DESKTOP_FORM_ID, MOBILE_FORM_ID];
  const LEGACY_FORM_ID = 'VyVJDq';
  const COMPANY_ID = 'XycL7U';

  function getWelcomeFormId() {
    return window.matchMedia('(max-width: 680px)').matches ? MOBILE_FORM_ID : DESKTOP_FORM_ID;
  }

  function clearKlaviyoPageLock() {
    document.body.classList.remove('klaviyo-prevent-body-scrolling');
    document.documentElement.classList.remove('klaviyo-prevent-body-scrolling');

    [document.body, document.documentElement].forEach((element) => {
      [
        'overflow',
        'overflow-x',
        'overflow-y',
        'position',
        'width',
        'height',
        'top',
        'right',
        'bottom',
        'left',
        'touch-action',
        'overscroll-behavior',
        'padding-right'
      ].forEach((property) => element.style.removeProperty(property));
    });
  }

  function deactivatePopup(popup) {
    if (!popup) return;
    popup.setAttribute('aria-hidden', 'true');
    popup.setAttribute('inert', '');
    popup.style.setProperty('opacity', '0', 'important');
    popup.style.setProperty('visibility', 'hidden', 'important');
    popup.style.setProperty('pointer-events', 'none', 'important');

    const panel = popup.querySelector('[data-testid="POPUP"]');
    if (panel) {
      panel.style.setProperty('opacity', '0', 'important');
      panel.style.setProperty('visibility', 'hidden', 'important');
      panel.style.setProperty('pointer-events', 'none', 'important');
    }
  }

  function reopenHiddenWelcomeForm(formId) {
    const form = document.querySelector(`form[data-testid="klaviyo-form-${formId}"]`);
    const popup = form?.closest('[role="dialog"][aria-label="POPUP Form"]');
    if (!popup || Number.parseFloat(window.getComputedStyle(popup).opacity || '1') > 0.01) return false;

    const panel = popup.querySelector('[data-testid="POPUP"]');
    popup.removeAttribute('inert');
    popup.setAttribute('aria-hidden', 'false');
    popup.style.animationName = 'none';
    popup.style.opacity = '1';
    popup.style.visibility = 'visible';
    popup.style.pointerEvents = 'auto';
    if (panel) {
      panel.style.animationName = 'none';
      panel.style.opacity = '1';
      panel.style.visibility = 'visible';
      panel.style.transform = 'none';
      panel.style.pointerEvents = 'auto';
    }
    document.body.classList.add('klaviyo-prevent-body-scrolling');
    return true;
  }

  function openWelcomeForm() {
    releaseStaleKlaviyoScrollLock();
    const formId = getWelcomeFormId();
    const requestToken = `${Date.now()}-${Math.random()}`;
    window.__alessaWelcomeOpenRequest = requestToken;
    if (reopenHiddenWelcomeForm(formId)) return;
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
    window.setTimeout(() => {
      if (!document.querySelector(`form[data-testid="klaviyo-form-${formId}"]`)) {
        window._klOnsite.push(['openForm', formId]);
      } else {
        reopenHiddenWelcomeForm(formId);
      }
    }, 900);
    window.setTimeout(() => reopenHiddenWelcomeForm(formId), 1800);
    window.setTimeout(() => {
      if (window.__alessaWelcomeOpenRequest === requestToken) reopenHiddenWelcomeForm(formId);
    }, 2600);
    window.setTimeout(() => {
      if (formId !== DESKTOP_FORM_ID
        && !document.querySelector(`form[data-testid="klaviyo-form-${formId}"]`)) {
        window._klOnsite.push(['openForm', DESKTOP_FORM_ID]);
      }
    }, 1900);
  }

  function ensureKlaviyo() {
    window._klOnsite = window._klOnsite || [];
    if (document.querySelector(`script[src*="/onsite/js/${COMPANY_ID}/klaviyo.js"]`)) return;
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://static.klaviyo.com/onsite/js/${COMPANY_ID}/klaviyo.js?company_id=${COMPANY_ID}`;
    script.dataset.alessaKlaviyo = COMPANY_ID;
    document.head.appendChild(script);
  }

  function hideDuplicateLegacyForm() {
    let removedLegacyPopup = false;
    document.querySelectorAll(`.kl-teaser-${LEGACY_FORM_ID}`).forEach((teaser) => {
      teaser.style.setProperty('display', 'none', 'important');
    });

    document.querySelectorAll('form[data-testid^="klaviyo-form-"]').forEach((form) => {
      if (WELCOME_FORM_IDS.some((formId) => form.dataset.testid === `klaviyo-form-${formId}`)) return;
      const copy = form.textContent.toLowerCase();
      if (!copy.includes('join the club')) return;
      const popup = form.closest('[data-testid="POPUP"]');
      if (popup) {
        popup.remove();
        removedLegacyPopup = true;
      }
    });
    return removedLegacyPopup;
  }

  function releaseStaleKlaviyoScrollLock() {
    let hasVisiblePopup = false;

    [...document.querySelectorAll('[role="dialog"][aria-label="POPUP Form"], [role="dialog"]:has([data-testid="POPUP"])')].forEach((popup) => {
      const styles = window.getComputedStyle(popup);
      const bounds = popup.getBoundingClientRect();
      const isVisible = styles.display !== 'none'
        && styles.visibility !== 'hidden'
        && Number.parseFloat(styles.opacity || '1') > 0.01
        && popup.getAttribute('aria-hidden') !== 'true'
        && bounds.width > 0
        && bounds.height > 0;

      if (isVisible) {
        hasVisiblePopup = true;
        return;
      }

      // Klaviyo keeps its full-screen dialog mounted after the close animation.
      // Make the hidden layer click-through so it cannot trap the page beneath it.
      deactivatePopup(popup);
    });

    if (!hasVisiblePopup) clearKlaviyoPageLock();
  }

  function bindKlaviyoScrollUnlock() {
    if (window.__alessaKlaviyoScrollUnlockBound) return;
    window.__alessaKlaviyoScrollUnlockBound = true;
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const close = event.target.closest('.klaviyo-close-form, .alessa-klaviyo-skip, [aria-label*="close" i]');
      if (!close) return;
      const popup = close.closest('[role="dialog"]');
      window.__alessaWelcomeOpenRequest = null;
      const finishClose = () => {
        deactivatePopup(popup);
        clearKlaviyoPageLock();
        releaseStaleKlaviyoScrollLock();
      };
      window.setTimeout(finishClose, 80);
      window.setTimeout(finishClose, 350);
      window.setTimeout(finishClose, 900);
    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      window.__alessaWelcomeOpenRequest = null;
      document.querySelectorAll('[role="dialog"][aria-label="POPUP Form"]').forEach(deactivatePopup);
      clearKlaviyoPageLock();
      window.setTimeout(releaseStaleKlaviyoScrollLock, 100);
      window.setTimeout(releaseStaleKlaviyoScrollLock, 500);
    });
  }

  function findOfferText(form, matcher) {
    const elements = [...form.querySelectorAll('h1, h2, h3, p, label, span, div')]
      .filter((element) => matcher.test((element.textContent || '').trim()));
    return elements.sort((first, second) => {
      const firstHeading = /^H[1-3]$/.test(first.tagName) ? 0 : 1;
      const secondHeading = /^H[1-3]$/.test(second.tagName) ? 0 : 1;
      return firstHeading - secondHeading
        || first.children.length - second.children.length
        || first.textContent.length - second.textContent.length;
    })[0];
  }

  function addOfferEyebrow(title, copy) {
    if (!title || title.parentElement?.querySelector(':scope > .alessa-klaviyo-eyebrow')) return;
    const eyebrow = document.createElement('p');
    eyebrow.className = 'alessa-klaviyo-eyebrow';
    eyebrow.textContent = copy;
    title.insertAdjacentElement('beforebegin', eyebrow);
  }

  function decorateOfferStep(form, step) {
    const submit = form.querySelector('button.klaviyo-form-button, button[type="submit"]');

    if (step === 'sms') {
      const title = findOfferText(form, /join sms/i);
      const intro = findOfferText(form, /vip text access|rare drops and events/i);
      const policy = findOfferText(form, /by submitting this form|consent to receive/i);
      const codeText = findOfferText(form, /^sms15$/i);
      const skip = findOfferText(form, /^no thanks/i);
      const phone = form.querySelector('input[type="tel"], input[autocomplete="tel"]');

      if (title) {
        if (title.textContent.trim() !== 'Join SMS & save 15%.') title.textContent = 'Join SMS & save 15%.';
        title.classList.add('alessa-klaviyo-title');
        addOfferEyebrow(title, 'A little extra from Alex');
      }
      if (intro) {
        const introCopy = 'Add your mobile number to upgrade your first-order offer from 10% to 15%, with first access to rare drops and events.';
        if (intro.textContent.trim() !== introCopy) intro.textContent = introCopy;
        intro.classList.add('alessa-klaviyo-body');
        if (!form.querySelector('.alessa-klaviyo-confirmation')) {
          const confirmation = document.createElement('p');
          confirmation.className = 'alessa-klaviyo-confirmation';
          confirmation.textContent = 'Your 10% email offer is already saved.';
          intro.insertAdjacentElement('afterend', confirmation);
        }
      }
      if (policy) {
        policy.classList.add('alessa-klaviyo-policy');
        policy.style.setProperty('font-size', 'clamp(8px, .58vw, 9px)', 'important');
        policy.style.setProperty('line-height', '1.35', 'important');
        policy.style.setProperty('text-align', 'left', 'important');
      }
      if (codeText) {
        let codeBlock = codeText;
        while (codeBlock.parentElement && codeBlock.parentElement !== form
          && codeBlock.parentElement.textContent.trim().toLowerCase() === 'sms15') {
          codeBlock = codeBlock.parentElement;
        }
        codeBlock.classList.add('alessa-klaviyo-code');
      }
      if (phone) phone.placeholder = 'Mobile number';
      if (submit && submit.textContent.trim() !== 'Send me 15% off') submit.textContent = 'Send me 15% off';
      if (skip) {
        if (skip.textContent.trim() !== 'No thanks, keep my 10% email offer') skip.textContent = 'No thanks, keep my 10% email offer';
        skip.classList.add('alessa-klaviyo-skip');
      }
      return;
    }

    if (step === 'birthday') {
      const title = findOfferText(form, /birthday treat/i);
      const intro = findOfferText(form, /enter your birthday|get your treat/i);
      if (title) {
        if (title.textContent.trim() !== 'A birthday treat, just for you.') title.textContent = 'A birthday treat, just for you.';
        title.classList.add('alessa-klaviyo-title');
        addOfferEyebrow(title, 'A little celebration from Alex');
      }
      if (intro) {
        const introCopy = 'Tell us your birthday and Alex will save a little celebration for you.';
        if (intro.textContent.trim() !== introCopy) intro.textContent = introCopy;
        intro.classList.add('alessa-klaviyo-body');
      }
      if (submit && submit.textContent.trim() !== 'Save my birthday treat') submit.textContent = 'Save my birthday treat';
    }
  }

  function decorateMobileEmailStep(form) {
    const title = findOfferText(form, /claim 10% off|take 10% off/i);
    const email = form.querySelector('input[type="email"]');
    const submit = form.querySelector('button.klaviyo-form-button, button[type="submit"]');
    if (title) {
      if (title.textContent.trim() !== 'Take 10% off your first order.') title.textContent = 'Take 10% off your first order.';
      title.classList.add('alessa-klaviyo-title');
      addOfferEyebrow(title, 'A welcome pour from Alex');
      if (!form.querySelector('.alessa-klaviyo-mobile-body')) {
        const body = document.createElement('p');
        body.className = 'alessa-klaviyo-body alessa-klaviyo-mobile-body';
        body.textContent = 'Organic and small batch wines, personally selected by Alex.';
        title.insertAdjacentElement('afterend', body);
      }
    }
    if (email && !form.querySelector('.alessa-klaviyo-first-name')) {
      const firstNameRow = document.createElement('div');
      firstNameRow.className = 'alessa-klaviyo-first-name';
      const firstName = document.createElement('input');
      firstName.type = 'text';
      firstName.name = '$first_name';
      firstName.placeholder = 'First name';
      firstName.autocomplete = 'given-name';
      firstName.setAttribute('aria-label', 'First name');
      firstNameRow.appendChild(firstName);
      const emailRow = email.closest('[data-testid="form-row"]') || email.parentElement;
      emailRow?.insertAdjacentElement('beforebegin', firstNameRow);

      const syncFirstName = () => {
        const profileEmail = email.value.trim();
        const profileFirstName = firstName.value.trim();
        if (!profileEmail || !profileFirstName) return;
        window._learnq = window._learnq || [];
        window._learnq.push(['identify', { '$email': profileEmail, '$first_name': profileFirstName }]);
      };
      form.addEventListener('submit', syncFirstName, true);
      submit?.addEventListener('click', syncFirstName, true);
    }
    if (email) email.placeholder = 'Email address';
    if (submit && submit.textContent.trim() !== 'Send me my 10%') submit.textContent = 'Send me my 10%';
  }

  function brandWelcomeForm() {
    const home = document.querySelector('#alessa-home');
    if (!home) return;

    const forms = WELCOME_FORM_IDS.flatMap((formId) => [
      ...document.querySelectorAll(`form[data-testid="klaviyo-form-${formId}"]`)
    ]);

    forms.forEach((form) => {
      const formCopy = form.textContent.toLowerCase();
      const phone = form.querySelector('input[type="tel"], input[autocomplete="tel"]');
      const isBirthday = formCopy.includes('birthday treat') || formCopy.includes('enter your birthday');
      const isSms = !isBirthday && (Boolean(phone) || formCopy.includes('join sms'));
      const step = isBirthday ? 'birthday' : isSms ? 'sms' : 'email';
      const isMobileForm = form.dataset.testid === `klaviyo-form-${MOBILE_FORM_ID}`;
      const isMobileViewport = window.matchMedia('(max-width: 680px)').matches;
      form.dataset.alessaBranded = 'true';
      form.dataset.alessaStep = step;
      if (isMobileForm || isMobileViewport) form.closest('[role="dialog"]')?.classList.add('alessa-mobile-form-dialog');

      let scaleWrapper = form.parentElement;
      for (let level = 0; level < 4; level += 1) scaleWrapper = scaleWrapper?.parentElement || null;
      scaleWrapper?.classList.add('alessa-klaviyo-scale-wrapper');

      let image = form.querySelector('img');
      if (!image && isMobileForm && step !== 'email') {
        const column = form.firstElementChild?.firstElementChild;
        if (column && !column.querySelector('.alessa-klaviyo-injected-image')) {
          const imageWrap = document.createElement('div');
          imageWrap.className = 'alessa-klaviyo-injected-image';
          image = document.createElement('img');
          imageWrap.appendChild(image);
          column.prepend(imageWrap);
        }
      }

      if (image) {
        image.src = step === 'sms'
          ? home.dataset.smsImage
          : step === 'birthday'
            ? home.dataset.birthdayImage
            : home.dataset.emailImage;
        image.alt = step === 'sms'
          ? 'Alex pouring a restaurant-selected red wine from the bar'
          : step === 'birthday'
            ? 'Alex pouring sparkling wine at the restaurant'
            : 'Alex holding one of her personally selected wines';
      }

      if (step !== 'email') {
        decorateOfferStep(form, step);
        return;
      }

      if (isMobileForm) {
        decorateMobileEmailStep(form);
        return;
      }

      const email = form.querySelector('input[type="email"]');
      const paragraphs = form.querySelectorAll('p');
      if (!email || paragraphs.length < 6) return;

      const copy = [
        'A welcome pour from Alex',
        'Take 10% off your first order.',
        '\u200b',
        'Organic and small batch wines I personally taste, pour and recommend.',
        '\u200b',
        'Join my Cellar List for new bottles, private drops and less guesswork.'
      ];

      paragraphs.forEach((paragraph, index) => {
        if (copy[index] && paragraph.dataset.alessaCopy !== 'true') {
          paragraph.textContent = copy[index];
          paragraph.dataset.alessaCopy = 'true';
        }
      });
      paragraphs[0]?.classList.add('alessa-klaviyo-eyebrow');
      paragraphs[1]?.classList.add('alessa-klaviyo-title');
      paragraphs[3]?.classList.add('alessa-klaviyo-body');
      paragraphs[5]?.classList.add('alessa-klaviyo-note');

      const firstName = form.querySelector('input[type="text"]');
      if (firstName) firstName.placeholder = 'First name';
      email.placeholder = 'Email address';
      const submit = form.querySelector('button.klaviyo-form-button');
      if (submit && submit.dataset.alessaCopy !== 'true') {
        submit.textContent = 'Send me my 10%';
        submit.dataset.alessaCopy = 'true';
      }
    });
  }

  function initialise() {
    const home = document.querySelector('#alessa-home');
    if (!home || home.dataset.alessaReady === 'true') return;
    home.dataset.alessaReady = 'true';

    const tab = home.querySelector('[data-welcome-tab]');
    const close = home.querySelector('[data-welcome-close]');
    if (tab && window.sessionStorage.getItem('alessa-welcome-dismissed') === 'true') tab.hidden = true;
    close?.addEventListener('click', () => {
      window.sessionStorage.setItem('alessa-welcome-dismissed', 'true');
      if (tab) tab.hidden = true;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
})();
